import styled from "@emotion/styled";
export const CollectionSelectContainer = styled.div`
  margin: 1rem 0;
  width: 400px;
`;
